import { Fragment } from 'react';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  crumbs: ReactNode[];
  title: ReactNode;
  titleExtra?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ crumbs, title, titleExtra, actions }: PageHeaderProps) {
  return (
    <div className="mp-pagehead">
      <div className="mp-crumbs">
        {crumbs.map((c, i) => (
          <Fragment key={i}>
            {i > 0 ? <i className="bi bi-chevron-right mp-crumbs__sep"></i> : null}
            <span className={i === crumbs.length - 1 ? 'mp-crumbs__cur' : ''}>{c}</span>
          </Fragment>
        ))}
      </div>
      <div className="mp-pagehead__row">
        <div className="mp-pagehead__title">
          <h2>{title}</h2>
          {titleExtra}
        </div>
        {actions ? <div className="mp-pagehead__actions">{actions}</div> : null}
      </div>
    </div>
  );
}
